import React, { ReactNode } from "react";
import { api } from "api/api";
import MacroButton, {
  MacroBulletItem,
  MacroBulletList,
  MacroContentStack,
} from "./MacroButton.component";
import { DialogContentText } from "@mui/material";

export default function AddPriceKeyPVALookupButton() {
  function InfoMessage(): ReactNode {
    return (
      <MacroContentStack>
        <DialogContentText>
          This process will find all attribute lookup tables where a ::MLP PVA
          with a ::PriceKey PVA under the same parent is looked up in this
          product line. It will then add the ::PriceKey PVA as a lookup column
          to each of these tables. See additional details below:
        </DialogContentText>
        <MacroBulletList>
          <MacroBulletItem>
            The ::PriceKey PVA will not be added to an attribute lookup table
            that already uses it in any column. So this process can be run
            multiple times without causing issues.
          </MacroBulletItem>
          <MacroBulletItem>
            This macro does not create new ::PriceKey PVAs. It also will not add
            the ::PriceKey PVA to this product line if it is not added already.
            For this functionality, run the macro to add the ::PriceKey PVA to
            the product line before running this.
          </MacroBulletItem>
          <MacroBulletItem>
            If the ::MLP PVA does not have the <strong>FLOAT</strong> data type
            or the ::PriceKey PVA does not have the <strong>STRING</strong> data
            type, this process will abort.
          </MacroBulletItem>
          <MacroBulletItem>
            It will be assumed that your tables do not have validation errors
            when running this macro. To avoid unexpected behavior, it is
            recommended that you validate your product line and fix all table
            validation <strong>ERRORS</strong> before running this.
          </MacroBulletItem>
        </MacroBulletList>
        <DialogContentText>
          Are you sure you want to continue?
        </DialogContentText>
      </MacroContentStack>
    );
  }

  return (
    <MacroButton
      performApiCall={(productLineId: string) =>
        api.addPriceKeyPVALookupColumns(productLineId)
      }
      apiCallDependencies={[]}
      buttonLabel={`Add ::PriceKey Lookup Columns to Product Line`}
      dialogTitle={`Add ::PriceKey Lookup Columns to Product Line`}
      tooltipText={`Adds ::PriceKey lookup columns to the product line.`}
      processingMessage={`Adding ::PriceKey lookup columns to product line. This may take a while.`}
      completionMessage="Addition completed. See detailed results below."
      timeOutMessage="Addition process timed out. See details below."
      informationContent={InfoMessage()}
      timeOutFailureDescription={`Request timed out. This could be due to an 
        especially large number of ::PriceKey instances to add lookup columns for.`}
      pvasUpdated={true}
      recommendValidation={true}
    />
  );
}
